export const aside = {
  groups: {
    general: 'General',
    management: 'Gestión',
    planning: 'Planificación',
    configuration: 'Configuración',
    account: 'Cuenta'
  },
  routes: {
    home: 'Inicio',
    dashboard: 'Panel de Control',
    activities: 'Actividades',
    users: 'Usuarios',
    profile: 'Perfil',
    testStore: 'Tienda de Prueba',
    products: 'Productos',
    categories: 'Categorías',
    customers: 'Clientes',
    sales: 'Ventas',
    stockMovements: 'Movimientos de Stock',
    cashMovements: 'Movimientos de Caja',
    settings: 'Configuración',
    saleModels: 'Modelos de Venta',
    tables: 'Mesas',
    appointments: 'Citas',
    commandes: 'Pedidos',
    activitySettings: 'Configuración de la actividad',
    pos: 'Punto de Venta',
    payments: 'Pagos',
    usersManagement: 'Gestión de Usuarios',
    approvisionnements: 'Aprovisionamientos',
    quickAccess: 'Acceso Rápido'
  }
}; 